<template>
    <div class="d-flex flex-row justify-content-between align-items-center">
        <div class="font-weight-lighter ruler pr-2">|</div>
        <div class="d-flex flex-column pt-2">
            <div
                v-if="user"
                class="text-primary text-truncate text-md name-title"
            >
                <span
                    v-b-tooltip.hover
                    :title="
                        $helpers.generateName(user.firstName, user.lastName)
                    "
                    class="text-truncate"
                >
                    <span
                        >{{ $t('common.hello') }},
                        {{
                            $helpers.generateName(user.firstName, user.lastName)
                        }}</span
                    >
                </span>
            </div>
            <div v-if="currentCurrencyId">
                <span
                    v-b-tooltip.hover
                    :title="$helpers.formatBalance(balance, currentCurrencyId)"
                    class="
                        balance-amount
                        font-weight-semi-bold
                        text-truncate text-semi-xl
                    "
                >
                    {{ $helpers.formatBalance(balance, currentCurrencyId) }}
                </span>
                <span
                    class="balance-title font-weight-semi-bold text-semi-sm"
                    >{{ $t('wallet.balance') }}</span
                >
            </div>
        </div>
        <div class="pl-4 pt-1">
            <b-button
                variant="ocean-green"
                class="text-white font-weight-500 min-w-124-px"
                @click="redirectStore"
            >
                <i class="far fa-usd-circle"> </i>
                {{ $t('button.top_up') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'UserBalance',
    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('user', ['balance']),
        ...mapGetters('website', ['currentCurrencyId']),
    },
    async mounted() {
        await this.$store.dispatch('user/fetchBalance');
    },
    methods: {
        redirectStore() {
            return this.$helpers.redirectTopUp();
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'UserBalance.scss';
</style>
